import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/axiosConfig";

/* ============================
   Async Thunks
============================ */

// Generate Lead ID
export const generateLeadId = createAsyncThunk(
  "leadIdGeneration/generate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/leadidgeneration/generate-leadid",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to generate Lead ID"
      );
    }
  }
);

// Delete Lead ID
export const deleteLeadId = createAsyncThunk(
  "leadIdGeneration/delete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        "/leadidgeneration/delete-leadid",
        { data: payload } // IMPORTANT for DELETE payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete Lead ID"
      );
    }
  }
);

/* ============================
   Slice
============================ */

const leadIdGenerationSlice = createSlice({
  name: "leadIdGeneration",
  initialState: {
    generatedLeadId: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetLeadIdState: (state) => {
      state.generatedLeadId = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* Generate Lead ID */
      .addCase(generateLeadId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(generateLeadId.fulfilled, (state, action) => {
        state.loading = false;
        state.generatedLeadId = action.payload;
        state.success = true;
      })
      .addCase(generateLeadId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Delete Lead ID */
      .addCase(deleteLeadId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLeadId.fulfilled, (state) => {
        state.loading = false;
        state.generatedLeadId = null;
        state.success = true;
      })
      .addCase(deleteLeadId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetLeadIdState } = leadIdGenerationSlice.actions;

export default leadIdGenerationSlice.reducer;
